/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, Table } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { colorArr, sortByOptions } from '../../helper';

const LifeTimeValueTable = ({ dataToShowForDatesSelected, month,
  title, filterBasedOnFilter, categorisedBasedOn, firstColumn, currentlyShow }) => {
  const { t } = useTranslation('common');

  const [selectedOptions, setSelectedOptions] = useState([])
  const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
  const allCategories = {}
  const currentDataByCategory = {};  
  const changeFilter = (value) => {
    setSelectedOptions(value)
  };

  const getColorCode = (salesPer) => {
    let colorCode;
    if (salesPer < 0) {
      const negValue = salesPer.split('-');
      if (negValue[1] < 5) {
        colorCode = colorArr[0].toString();
      }
      else if (negValue[1] >= 5 && negValue[1] < 10) {
       colorCode = colorArr[1].toString();
      }
      else if (negValue[1] >= 10 && negValue[1] < 15) {
        colorCode = colorArr[2].toString();
      }
      else if (negValue[1] >= 15 && negValue[1] < 20) {
        colorCode = colorArr[3].toString();
     }
     else if (negValue[1] >= 20 && negValue[1] < 25) {
       colorCode = colorArr[4].toString();
      }
     else if (negValue[1] >= 25 && negValue[1] < 30) {
       colorCode = colorArr[5].toString();
      }
      else if (negValue[1] >= 30 && negValue[1] < 35) {
        colorCode = colorArr[6].toString();
      }
      else if (negValue[1] >= 35 && negValue[1] < 40) {
        colorCode = colorArr[7].toString();
      }
      else if (negValue[1] >= 40 && negValue[1] < 45) {
        colorCode = colorArr[8].toString();
      }      
      else if (negValue[1] >= 45) {
        colorCode = colorArr[9].toString();
      }
    }
    else if (salesPer > 0) {
      if (salesPer < 5) {
        colorCode = colorArr[10].toString();
      }
     else if (salesPer >= 5 && salesPer < 10) {
        colorCode = colorArr[11].toString();
      }
       else if (salesPer >= 10 && salesPer < 15) {
        colorCode = colorArr[12].toString();
      }
      else if (salesPer >= 15 && salesPer < 20) {
        colorCode = colorArr[13].toString();
      }
      else if (salesPer >= 20 && salesPer < 25) {
        colorCode = colorArr[14].toString();
      }
      else if (salesPer >= 25 && salesPer < 30) {
        colorCode = colorArr[15].toString();
      }
      else if (salesPer >= 30 && salesPer < 35) {
        colorCode = colorArr[16].toString();
      }
      else if (salesPer >= 35 && salesPer < 40) {
        colorCode = colorArr[17].toString();
      }
      else if (salesPer >= 40 && salesPer < 45) {
        colorCode = colorArr[18].toString();
      }
      else if (salesPer >= 45) {
        colorCode = colorArr[19].toString();
      }
    }
    else if (salesPer === '0' || salesPer === 'NaN')
    {
      colorCode = colorArr[21].toString();
    }
    else {
      colorCode = colorArr[20].toString();
    }
    return colorCode;
  }

  const dataToPlot =  dataToShowForDatesSelected?.map((item) => {
    const updated = { ...item };
    const {yearMonth, monthSinceFirstOrderDTOs} = updated
    updated.yearMonth = `${moment().month(item?.month).subtract(1, 'months').format('MMM')}-${item?.year}`
    updated.monthSinceFirstOrderDTOs = item?.monthSinceFirstOrderDTOs?.map((innerItem) => {
      const innerUpdated = { ...innerItem };
      const {backColor, percentage} = innerUpdated
      innerUpdated.backColor = getColorCode(innerItem.percentage)
      innerUpdated.percentage = innerItem.percentage === 'NaN' ? 0 : innerItem.percentage
      return innerUpdated
    })

    return updated
  });

  const getPercentage = (currValue, preValue) => {
    let v = 0;
    if (preValue > 0) {
      v = (((currValue - preValue) / preValue) * 100).toFixed(2) || '0.00';
    }
    else {
      v = 0;
    }
    return v;
  }

  const tableHeader = [];
  
  dataToShowForDatesSelected?.forEach((item, index) => {
    if (index === 0)
    {
      item?.monthSinceFirstOrderDTOs?.map(innerItem => (
        tableHeader.push(moment(innerItem?.yearMonth).format('MMM-YYYY'))
      ))      
    }
  })

  return (
    <Col xs="12">
      <Card className="pb-3 show-categ-daily-sales">
        <CardBody>
          <div className="card__title row align-items-center">
            <h5 className="bold-text col-md-5">{title}</h5>            
            <Table responsive striped className="dashboard__table-orders" width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', width: '500px' }}>First Order at</th>
                  <th style={{ textAlign: 'right' }}>New Customers</th>
                  <th style={{ textAlign: 'right' }}>*CAC</th>
                  <th style={{ textAlign: 'right' }}>R-%</th>
                  <th style={{ textAlign: 'right' }}>First Order</th>
                  
                      {tableHeader?.map(item => (
                        <th style={{ textAlign: 'right'}}>{item}</th>
                      ))}
                    
                 
                </tr>
              </thead>
              <tbody>
                {dataToPlot?.length ? dataToPlot?.map(dataValue => (
                  <tr>
                    <td style={{ paddingTop: '4px', paddingBottom: '4px', minWidth: '120px' }}>{dataValue.yearMonth}
                    </td>
                    <td style={{ paddingTop: '4px', paddingBottom: '4px', paddingRight: '0px',
                     minWidth: '120px', textAlign: 'right' }}>{dataValue.totalNewCustomers}
                    </td>
                    <td style={{ paddingTop: '4px', paddingBottom: '4px', paddingRight: '0px',
                    textAlign: 'right' }}>
                      {setCurrencyFormat(Number(dataValue?.customerAcquisitionCost).toFixed(0), true)}

                    </td>
                    <td style={{ paddingTop: '4px', paddingBottom: '4px', paddingRight: '0px',
                     textAlign: 'right' }}>{dataValue.repeteadCustomerPercentage} %
                    </td>
                      <td style={{
                        paddingTop: '2px', paddingBottom: '2px', paddingRight: '0px', marginLeft: '0px',
                        marginRight: '0px'
                      }}>
                        <Card body style={{
                          background: colorArr[20],
                          width: '90px',
                          height: '50px', marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>
                            {setCurrencyFormat(Number(dataValue?.firstOrder).toFixed(2), true)}
                          </CardText>                        
                        </Card>
                      </td>   
                      {dataValue?.monthSinceFirstOrderDTOs?.map(item =>(
                        <td style={{
                          paddingTop: '2px', paddingBottom: '2px', paddingRight: '0px', marginLeft: '0px',
                          marginRight: '0px'
                        }}>
                          <Card body style={{
                            background: item?.backColor,
                            width: '90px',
                            height: '50px', marginBottom: '0px',
                            marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                            paddingRight: '6px'
                          }}>
                            <CardText style={{
                              color: Number(item?.percentage) === 0 ? '#737070' : '#000000', 
                              fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                              paddingTop: '0px', marginBottom: '0px'
                            }}>
                              {setCurrencyFormat(Number(item?.avgOrderAmount).toFixed(2), true)}
                            </CardText> 
                            {Number(item?.percentage) < 0 && (
                            <CardText style={{
                              color: Number(item?.percentage) === 0 ? '#737070' : '#000000', 
                              fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                              paddingTop: '0px', marginBottom: '0px'
                                }}>
                                  <span>
                                   <svg width="20" height="20" fill="currentColor" viewBox="0 0 30 30">
                                    <path
                                       d="M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,
                                                  14.29L22,12V18H16Z"
                                    />
                                  </svg>
                                  {Number(item?.percentage).toFixed(2)} %
                              </span>
                            </CardText>)}
                            {Number(item?.percentage) > 0 && (
                            <CardText style={{
                              color: Number(item?.percentage) === 0 ? '#737070' : '#000000', 
                              fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                              paddingTop: '0px', marginBottom: '0px'
                                }}>
                                  <span>
                                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 30 30">
                                      <path
                                        d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,
                                                          12L13.41,16L19.71,9.71L22,12V6H16Z"
                                      />
                                    </svg>
                                      {Number(item?.percentage).toFixed(2)} %
                                  </span>
                            </CardText>)}
                            {Number(item?.percentage) === 0 && (
                              <CardText style={{
                                color: Number(item?.percentage) === 0 ? '#737070' : '#000000', 
                                fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                                paddingTop: '0px', marginBottom: '0px'
                                  }}>
                                {Number(item?.percentage).toFixed(2)} %
                              </CardText>)}                      
                          </Card>
                        </td>   
                      ))}                 
                  </tr>
                )) : 'No data to display'}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

LifeTimeValueTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  firstColumn: PropTypes.string,
  month: PropTypes.object.isRequired,
  title: PropTypes.string,
  filterBasedOnFilter: PropTypes.func.isRequired,
  categorisedBasedOn: PropTypes.string,
  currentlyShow: PropTypes.object.isRequired
};

LifeTimeValueTable.defaultProps = {
  title: 'Life Time Value By Month',
  firstColumn: 'Product Category',
  categorisedBasedOn: 'productCategory',
}

export default LifeTimeValueTable;

